import { firestoreService } from '../services/firestoreService';

export const fetchCampaigns = async () => {
  try {
    const filters = [{ field: 'active', operator: '==', value: true }];
    return await firestoreService.getCollection('campaigns', filters);
  } catch (error) {
    console.log(error);
  }
};
